import { buildAddVariantsVariable } from "../useCreateProduct";

import getEditedVariants from "./getEditedVariants";

const buildEditVariantsVariable = (
  { rows, columns, ...variantTabProps },
  { variants, options, ...product },
  hasVariants
) => {
  if (!hasVariants) {
    return {
      ...(variants.length && { deleted: variants.map(({ id }) => id) })
    };
  }

  const deleted = getDeletedVariants(variants, rows);

  const edited = getEditedVariants(rows, columns, variants, options);

  const created = getCreatedVariants(rows, columns, hasVariants);

  return {
    deleted: deleted.length ? deleted : null,
    edited: edited.length ? edited : null,
    created: created && created.length ? created : null
  };
};

const getDeletedVariants = (variants, rows) =>
  variants
    .map(({ id }) => id)
    .filter((variantId) => !rows.find((row) => row.id === variantId));

const getCreatedVariants = (rows, columns, hasVariants) =>
  buildAddVariantsVariable(
    {
      rows: rows.filter((row) => !row.id),
      columns
    },
    hasVariants
  );

export default buildEditVariantsVariable;
